"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgIconRefresh = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgIconRefresh = function SvgIconRefresh(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#si_refresh__clip0)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.341-2.341A2.25 2.25 0 0012.75-3h.75A1.5 1.5 0 0115-1.5v.75a2.25 2.25 0 00-.659-1.591zM15 12.75A2.25 2.25 0 0112.75 15h.75a1.5 1.5 0 001.5-1.5v-.75zM-.75 15A2.25 2.25 0 01-3 12.75v.75A1.5 1.5 0 00-1.5 15h.75zM-3-.75A2.25 2.25 0 01-.75-3h-.75A1.5 1.5 0 00-3-1.5v.75zm13.781 2.813h-.765a5.626 5.626 0 01-1.766 9.094V9.232a3.938 3.938 0 00-.563-6.79v1.59a.844.844 0 11-1.687 0V1.218a.844.844 0 01.844-.844h3.937a.844.844 0 010 1.688zM1.22 10.032h.765A5.626 5.626 0 013.75.937v1.925a3.938 3.938 0 00.563 6.79V8.064a.844.844 0 111.687 0v2.813a.844.844 0 01-.844.844H1.22a.844.844 0 010-1.688z",
    fill: "currentColor"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "si_refresh__clip0"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  }))));
};

exports.SvgIconRefresh = SvgIconRefresh;